import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  getCityDrillDownApi,
  getSLAAvgDrillDownApi,
} from "../../../service/api_calls/multiBranchOrderAnalysis/multiBranchOrderSummaryApi";
import ModalCard from "../../../components/ModalCard";
import ModalCardWithHeaderFooter from "../../../components/Cards/ModalCardWithHeaderFooter";
import {
  blackShade19,
  borderTextBoxColor,
  lightOrange05,
  lightOrange06,
  lightYellowShade01,
  lightYellowShade02,
  orangeShade08,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ThreeDotLoader from "../../../components/ThreeDotLoader";
import { formatMinutes } from "../../../utils/helper";

// Function to format currency with ₹ symbol

const OrderSaleAvgSectionDrillDown = ({
  allBranchIds,
  open,
  setOpen,
  hideOrderCount,
  masterBranchInfo,
  getBrandNameById,
}) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState(null);

  const getSLAAvgDrillMBData = async () => {
    setLoading(true);

    const currentYear = moment().year();

    const requestData = {
      subBusinessIds: allBranchIds || "",
      params: {
        from: moment(`2022-01-01`).startOf("day").valueOf(),
        to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
      },
    };

    const result = await getSLAAvgDrillDownApi(requestData);

    if (result?.details?.length > 0) {
      const sortedList = result?.details.sort((a, b) => {
        if (a.avgOrderCycleTime === 0) return 1; 
        if (b.avgOrderCycleTime === 0) return -1; 
        return a.avgOrderCycleTime - b.avgOrderCycleTime; 
      });

      setTableData(sortedList || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    getSLAAvgDrillMBData();
    return () => {};
  }, []);

  return (
    <ModalCard
      open={open}
      handleClose={() => {
        setOpen(false);
      }}
      width={"65%"}
    >
      <ModalCardWithHeaderFooter
        title={`Average Order Value by Business`}
        hideFooter
        // headerBg={lightBlueColor08}
        // headerTextColor={blueColor04}
      >
        {loading ? (
          <ThreeDotLoader />
        ) : (
          <Box sx={styles.tableWrapper}>
            {tableData && (
              <TableContainer sx={styles.tableContainer} component={Box}>
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        position: "sticky !important",
                        top: 0,
                        backgroundColor: lightOrange05,
                        zIndex: 8,
                        borderRadius: "5px 5px 0 0",
                        py: "12px",
                      }}
                    >
                      <TableCell sx={styles.tableCell} align="center">
                        Business Name
                      </TableCell>

                      <TableCell sx={styles.tableCell} align="center">
                        Average Order Value
                      </TableCell>

                      <TableCell sx={styles.tableCell} align="center">
                        Average Approval Time
                      </TableCell>

                      <TableCell sx={styles.tableCell} align="center">
                        Average Shipping Time
                      </TableCell>

                      <TableCell sx={styles.tableCell} align="center">
                        Average Order Cycle Time
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: whiteColor }}>
                    {tableData?.map((business, index) => {
                      return (
                        <>
                          <TableRow
                            sx={{
                              borderBottom: `1px solid ${borderTextBoxColor}`,
                              verticalAlign: "top",
                              px: "12px",
                              py: "8px",
                            }}
                          >
                            <TableCell
                              key={business.businessId + index}
                              align="center"
                              sx={styles.tableBodyCell}
                            >
                              {getBrandNameById(business?.businessId) || "-"}{" "}
                              {business?.businessId ==
                                masterBranchInfo?.masterBranchId ||
                              business.businessId == masterBranchInfo?.id ? (
                                <Typography
                                  component="span"
                                  fontSize={11.5}
                                  color={orangeShade08}
                                  ml={0.3}
                                >
                                  (Main Branch)
                                </Typography>
                              ) : (
                                ""
                              )}
                            </TableCell>

                            <TableCell
                              key={business?.businessId + index}
                              align="center"
                              sx={styles.tableBodyCell}
                            >
                              {`₹ ${business?.avgOrderValue?.toLocaleString(
                                "en-IN"
                              )}`}
                            </TableCell>

                            <TableCell
                              key={business?.businessId + index}
                              align="center"
                              sx={styles.tableBodyCell}
                            >
                              {formatMinutes(business?.avgApprovalTime) || "0"}
                            </TableCell>

                            <TableCell
                              key={business?.businessId + index}
                              align="center"
                              sx={styles.tableBodyCell}
                            >
                              {formatMinutes(business?.avgShippingTime) || "0"}
                            </TableCell>

                            <TableCell
                              key={business?.businessId + index}
                              align="center"
                              sx={styles.tableBodyCell}
                            >
                              {formatMinutes(business?.avgOrderCycleTime) ||
                                "0"}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        )}
      </ModalCardWithHeaderFooter>
    </ModalCard>
  );
};

export default OrderSaleAvgSectionDrillDown;

const styles = {
  tableWrapper: {
    width: "100%",
    border: `1px solid ${lightOrange06}`,
    borderBottom: "none",
    overflow: "hidden",
    borderRadius: "5px",
  },

  tableContainer: {
    maxWidth: "100%",
    borderRadius: "5px",
    overflowY: "scroll",
    maxHeight: "55vh",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "2px",
      height: "2px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tableCell: {
    color: orangeShade08,
    fontSize: 11.5,
    fontWeight: "500",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: lightOrange05,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "10px 15px !important",
    textAlign: "start",
  },

  statusBoxChip: {
    backgroundColor: lightYellowShade01,
    border: "1px solid" + lightYellowShade02,
    borderRadius: "4px",
    width: "max-content",
    p: "0 4px",
    display: "flex",
    alignItems: "center",
    height: "20px",
  },
};
